exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redirectLinkComponent-redirectLink {\n  text-decoration: none; }\n\n.redirectLinkComponent-linkText {\n  font-family: 'Lato-Regular', sans-serif;\n  color: var(--text); }\n\n.linkText {\n  color: #ffffff; }\n", ""]);

// exports
